import BaseAPI from "../../../baseAPI";

class ShippingAPI extends BaseAPI {
	constructor() {
		super("/store/transaction/checkout/shipping")
	}

	calculateCost(data) {
		return this.post("/calculate-cost", data, true)
	}
}

export { ShippingAPI as default }